import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between q-px-md q-pt-md q-mb-20" }
const _hoisted_2 = { class: "col-grow fw-600 fs-17px text-cool-gray-100 k-dialog__title" }

import { toRef } from 'vue'
import type { StyleValue } from 'vue'

interface IProps {
  modelValue?: boolean
  containerClass?: string | (string | Record<string, boolean>)[] | Record<string, boolean>
  containerStyle?: StyleValue | undefined
  contentStyle?: StyleValue | undefined
  contentClass?: string | (string | Record<string, boolean>)[] | Record<string, boolean>
  title?: string
}

interface IEmits {
  (event: 'update:modelValue', data: boolean): void
  (event: 'before-hide', data: void): void
  (event: 'hide', data: void): void
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KDialog', inheritAttrs: false },
  __name: 'KDialog',
  props: {
    modelValue: { type: Boolean, default: false },
    containerClass: { default: '' },
    containerStyle: { type: [Boolean, null, String, Object, Array], default: '' },
    contentStyle: { type: [Boolean, null, String, Object, Array], default: '' },
    contentClass: { default: '' },
    title: { default: '' }
  },
  emits: ["update:modelValue", "before-hide", "hide"],
  setup(__props: any, { emit: __emit }) {



const props = __props

const emit = __emit

const showDialogRef = toRef(() => props.modelValue)

return (_ctx: any,_cache: any) => {
  const _component_KIcon = _resolveComponent("KIcon")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, _mergeProps({
    class: ["k-dialog", [['left', 'right'].includes(_ctx.$attrs['position'] as string) && 'k-dialog__full-height']],
    "model-value": showDialogRef.value
  }, _ctx.$attrs, {
    onHide: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('hide'))),
    onBeforeHide: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('before-hide'))),
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
  }), {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["k-dialog__container full-width shadow-4 bg-off-white-10 q-pa-sm custom-scrollbar", [
        ['left', 'right'].includes(_ctx.$attrs['position'] as string) &&
          'k-dialog__container--full-height full-height column',
        __props.containerClass,
      ]]),
        style: _normalizeStyle(__props.containerStyle)
      }, [
        _renderSlot(_ctx.$slots, "header", {}, () => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(__props.title), 1),
            _renderSlot(_ctx.$slots, "call-to-action", {}, () => [
              _createElementVNode("span", {
                class: "rounded-circle q-pa-xs bg-white flex inline cursor-pointer",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
              }, [
                _createVNode(_component_KIcon, {
                  name: "close-rounded",
                  size: "24px",
                  color: "cool-gray-70"
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass([[['left', 'right'].includes(_ctx.$attrs['position'] as string) && 'flex-1', __props.contentClass], "bg-white rounded-24 q-py-20 q-px-md"]),
          style: _normalizeStyle(__props.contentStyle)
        }, [
          _renderSlot(_ctx.$slots, "content")
        ], 6)
      ], 6)
    ]),
    _: 3
  }, 16, ["class", "model-value"]))
}
}

})